import RefundsUIModel from './refunds';

export default class FulfillRefundUIModel {
  constructor({
    cuentaPremier = '',
    fulfillRefundResult = {
      reason: '',
      code: '',
      description: '',
      subCode: '',
    },
    iata = '',
    recIdSolicitud = '',
    recordLocator = '',
    refundDriver = {
      actionType: '',
      applicationClient: '',
      applicationMode: '',
    },
    refunds = [],
    reinstallPoints = {
      reinstallPoIntsApplied: '',
      reinstalledMiles: '',
      crisTrxId: '',
      reinstallFeeTicketNumber: '',
    },
  }) {
    this.cuentaPremier = cuentaPremier;
    this.fulfillRefundResult = fulfillRefundResult;
    this.iata = iata;
    this.recIdSolicitud = recIdSolicitud;
    this.recordLocator = recordLocator;
    this.refundDriver = refundDriver;
    this.refunds = refunds.map(refund => new RefundsUIModel(refund));
    this.reinstallPoints = reinstallPoints;
  }
}